import { BreakpointObserver } from '@angular/cdk/layout';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, Observable, Subject, takeUntil } from 'rxjs';
import { AccountService } from 'src/app/services/account.service';
import { AuthService } from 'src/app/services/auth.service';
import { ModalService } from 'src/app/services/modal.service';
import { OfflineStorageService } from 'src/app/services/offline-storage.service';
import { SharedService } from 'src/app/services/shared.service';
import { setLoadingSpinner } from 'src/app/store/actions/shared.action';
import { AppState } from 'src/app/store/app.state';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss']
})
export class AdminLayoutComponent implements OnInit, AfterViewInit {
  userProfile: any;

  ngUnsubscribe = new Subject<void>();

  schoolOpen: Boolean = false;
  schoolAbout: Boolean = false;
  schoolCalendar: Boolean = false;
  schoolFacilities: Boolean = false;
  curriculumOpen: Boolean = false;
  financeOpen: Boolean = false;
  SchemesOpen: Boolean = false;
  adminOpen: Boolean = false;
  registrarOpen: Boolean = false;

  activeStepIndex = 0;

  applicationCompleted = false;
  preEnrollmentCompleted = false;
  firstInterviewCompleted = false;
  academicReqCompleted = false;
  secondInterviewCompleted = false;
  LOACompleted = false;
  enrollmentCompleted = false;

  @ViewChild('sidenav') sidenav!: MatSidenav;

  pageTitle: string = '';

  segment: any;

  constructor(
    private store: Store<AppState>,
    private sharedService: SharedService,
    public router: Router,
    private authService: AuthService,
    private offlineStorageService: OfflineStorageService,
    private cdr: ChangeDetectorRef,
    private accountService: AccountService,
    private observer: BreakpointObserver,
    private modalService: ModalService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    const path = window.location.pathname;
    this.segment = path.split('/')[1];
    // this.sharedService.sidenavToggle$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
    //   this.sidenav.toggle();
    // });

    this.loadUserProfile();
  }

  private async loadUserProfile() {
    const user = await this.offlineStorageService.getObject('user');
    this.userProfile = JSON.parse(user);
  }

  ngAfterViewInit() {
    // this.observer.observe(['(max-width: 1024px)']).subscribe(result => {
    //   if (result.matches) {
    //     this.sidenav.mode = 'over';
    //     this.sidenav.close();
    //     this.cdr.detectChanges();
    //   } else {
    //     this.sidenav.mode = 'side';
    //     this.sidenav.open();
    //     this.cdr.detectChanges();
    //   }
    // });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
  }

  logout() {
    this.store.dispatch(setLoadingSpinner({ status: true }))
    this.authService.autoLogout(this.segment);
  }

  getImg(name) {
    return `assets/img/sidenav/${name}.svg`
  }

  changeStep(step: number) {
    this.activeStepIndex = step;
  }

  get orgHeaderContent() {
    return this.userProfile?.agn_org?.contents?.find((e) => e?.type == 'header1')
  }

  get scpHeaderContent() {
    return this.userProfile?.scp_org?.contents?.find((e) => e?.type == 'header1')
  }

  queuePage() {
    this.router.navigateByUrl('/home/queue')
  }

  can(permissionName: string[]): boolean {
    return permissionName.some(g => this.userProfile?.permissions?.includes(g)); 
  }

navGrp(groups: string[]): boolean {
  if (!this.userProfile || !this.userProfile.nav_grp) return false;
  return groups.some(g => this.userProfile.nav_grp.includes(g));
}

  hasRole(roleName: string): boolean {
    return this.userProfile?.roles?.includes(roleName);
  }
  private setPageTitle(route: ActivatedRoute) {
    let activeRoute = route;
    while (activeRoute.firstChild) {
      activeRoute = activeRoute.firstChild;
    }
    this.pageTitle = activeRoute.snapshot.data['title'] || '';
  }  

  canViewEngagement(): boolean {
    const u = this.userProfile;
    return (
      this.hasRole('super-user') ||
      u?.voucherCreate === 'yes' ||
      u?.voucherIssue === 'multiple' ||
      u?.voucherApprove1 === 'yes' ||
      u?.voucherApprove2 === 'yes' ||
      u?.voucherRelease === 'yes'
    );
  }

}
